/* eslint-disable max-len */
import 'react';

const TagSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="currentColor"
        {...props}
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(10.707107, 9.498647) scale(-1, 1) rotate(-45.000000) translate(-10.707107, -9.498647) translate(4.707107, 0.498647)">
                <path d="M1.40504435,5.20450785 L5.09771617,1.51183603 C5.48824046,1.12131173 6.12140544,1.12131173 6.51192974,1.51183603 L10.233368,5.23327433 C10.59994,5.59984629 10.8098531,6.09443384 10.8188531,6.61276675 L10.9646708,15.010861 C10.9838467,16.1152641 10.1040963,17.0261048 8.99969331,17.0452808 C8.98812068,17.0454817 8.97654653,17.0455822 8.96497217,17.0455822 L2.96557508,17.0455822 C1.87454146,17.0455822 0.98481746,16.1711725 0.965876493,15.0803033 L0.819559323,6.65344256 C0.810141635,6.11104861 1.0214561,5.58809609 1.40504435,5.20450785 Z" id="矩形" fill="currentColor"></path>
                <path d="M6,13.8800326 C7.1045695,13.8800326 8,12.9846021 8,11.8800326 C8,10.7754631 7.1045695,9.88003255 6,9.88003255 C4.8954305,9.88003255 4,10.7754631 4,11.8800326 C4,12.9846021 4.8954305,13.8800326 6,13.8800326 Z" id="椭圆形" fill="#FFFFFF"></path>
            </g>
        </g>
    </svg>
);

export default TagSvg;
